import joyce from '../assets/img/joyce.jpg';
import ana from '../assets/img/anita.jpg';
import anaLuz from '../assets/img/anaLuz.JPG';
import yunid from '../assets/img/yunid2.jpg';
import herbie from '../assets/img/herbie.jpg';
import daniel from '../assets/img/daniel2.jpg';
import noris from '../assets/img/noris.jpg';

export const OFFICIALS = [
    {
        id: 0,
        name: 'Joyce L. Ortiz',
        title: 'Secretaria',
        picture: joyce,
        altText: 'official'
    },
    {
        id: 1,
        name: 'Ana Guevara',
        title: 'Sub-Tesorera',
        picture: ana,
        altText: 'official'
    },
    {
        id: 2,
        name: 'Ana L. Molina',
        title: 'Tesorera',
        picture: anaLuz,
        altText: 'official'
    },
    {
        id: 3,
        name: 'Yunid Tavarez',
        title: '',
        picture: yunid,
        altText: 'official'
    },
    {
        id: 4,
        name: 'Herbert Gandia',
        title: '',
        picture: herbie,
        altText: 'official'
    },
    {
        id: 5,
        name: 'Daniel Carrales',
        title: '',
        picture: daniel,
        altText: 'official'
    },
    {
        id: 6,
        name: 'Noris Rodriguez',
        title: '',
        picture: noris,
        altText: 'official'
    }
]; 